import React, { FunctionComponent } from 'react'
import { IExportarExtrato } from '../../domain/usecases/ExportarExtrato'
import SelectExtratoImpl from '../../domain/usecases/SelectExtratoImpl'
import ContainerPage from '../../../../shared/components/ContainerPage'
import ListExtrato from '../components/ListExtrato'
import FiltroExtrato from '../components/ListExtrato/components/FiltroExtrato'
import CartaoNew from '../components/CartaoNew'

interface ExtratoProp {
  exportarExtrato: IExportarExtrato
  selectExtrato: SelectExtratoImpl
}

const Extrato: FunctionComponent<ExtratoProp> = ({
  exportarExtrato,
  selectExtrato,
}) => {
  return (
    <ContainerPage
      breadCrumb="Pagamentos/Extrato"
      showScaffold={true}
      showFooterScaffold={false}
      header={<CartaoNew />}
      filter={<FiltroExtrato exportarExtrato={exportarExtrato} />}
    >
      <ListExtrato selectExtrato={selectExtrato} />
    </ContainerPage>
  )
}
export default Extrato
